import React from 'react';
import { motion } from 'framer-motion';
export function Garantia() {
  return <section id="garantia" className="bg-gradient-to-br from-brand-green-dark to-[#0A1F12] border-y border-brand-success/20 py-[60px] md:py-[80px] text-center" data-id="element-129">
      <div className="max-w-[800px] mx-auto px-5 flex flex-col items-center" data-id="element-130">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-[64px] mb-5" data-id="element-131">
          🛡️
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[clamp(24px,4vw,32px)] font-black mb-6 text-brand-success tracking-[1px]" data-id="element-132">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[17px] text-brand-gray max-w-[500px] mx-auto leading-[1.7] flex flex-col gap-3" data-id="element-133">
          <p data-id="element-134">Usás el sistema. Lo probás en tus materias.</p>
          <p data-id="element-135">
            Si en 7 días no cambió cómo estudiás: devolución del 100% sin
            formularios, sin drama.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="inline-flex items-center bg-brand-success/10 border-[1.5px] border-brand-success/35 rounded-xl py-3 px-6 mt-8" data-id="element-136">
          <span className="text-[14px] font-bold text-brand-success" data-id="element-137">
            Tasa de devoluciones: menos del 1%.
          </span>
        </motion.div>
      </div>
    </section>;
}